function Home(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={30} height={23.33} {...props}>
      <g data-name="Group 6479">
        <path
          data-name="Icon awesome-home"
          d="m14.601 6.052-9.6 7.908v8.536a.833.833 0 0 0 .833.833l5.836-.015a.833.833 0 0 0 .829-.833v-4.985a.833.833 0 0 1 .833-.833h3.333a.833.833 0 0 1 .833.833v4.981a.833.833 0 0 0 .833.836l5.834.016a.833.833 0 0 0 .836-.833v-8.542l-9.6-7.9a.635.635 0 0 0-.8-.002Zm15.167 5.375-4.354-3.589V.624a.625.625 0 0 0-.625-.625h-2.915a.625.625 0 0 0-.625.625v3.782L16.587.57a2.5 2.5 0 0 0-3.177 0L.227 11.427a.625.625 0 0 0-.083.88l1.327 1.615a.625.625 0 0 0 .881.085L14.601 3.916a.635.635 0 0 1 .8 0l12.249 10.09a.625.625 0 0 0 .88-.083l1.328-1.614a.625.625 0 0 0-.089-.882Z"
          fill="#051828"
        />
      </g>
    </svg>
  );
}

export default Home;
